export const env = "prod"

export const backendUrlDev = "https://xfvdcslyjf.execute-api.us-east-1.amazonaws.com"
export const backendUrlProd = "https://c33hscgtn1.execute-api.us-east-1.amazonaws.com"
export const baseUrlProd = "https://carsonoffill.com"
export const baseUrlDev = "http://localhost:3000"
